import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { InputNumber, P, H2 } from '@yuhu-inc/yuhui';

const InputNumberContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const StyledP = styled(P)`
  ${media.mobile`
    padding: 0;
  `};
`;

export const SignerRoleInputs = ({
  numOfApplicants,
  numOfGuarantors,
  numberofOccupants,
  numOfRentableItems,
  numOfIncentives,
  minApplicants = 0,
  minGuarantors = 0,
  minOccupants = 0,
  minRentableItems = 0,
  minIncentives = 0,
  setFieldValue,
  isLease,
  isConditionalAddendum,
}) => {
  const setInputValue = (fieldValue, newValue) => {
    if (newValue >= minApplicants || newValue >= minGuarantors || newValue >= minRentableItems) {
      setFieldValue(fieldValue, newValue);
    }
  };

  return (
    <InputNumberContainer>
      <InputNumber
        contentKey="landlordPortal.documentTemplate.applicants"
        name={'max_num_applicants'}
        min={minApplicants}
        value={numOfApplicants}
        callback={(newValue) => setInputValue('max_num_applicants', newValue)}
      />
      <InputNumber
        contentKey="landlordPortal.documentTemplate.guarantors"
        name={'max_num_guarantors'}
        min={minGuarantors}
        value={numOfGuarantors}
        callback={(newValue) => setInputValue('max_num_guarantors', newValue)}
      />

      <InputNumber
        contentKey="landlordPortal.documentTemplate.occupants"
        name={'max_num_occupants'}
        min={minOccupants}
        value={numberofOccupants}
        callback={(newValue) => setInputValue('max_num_occupants', newValue)}
      />
      {(isLease || isConditionalAddendum) && (
        <React.Fragment>
          <H2 contentKey="landlordPortal.documentTemplateDetailsForm.additionalLeaseItems" />
          <StyledP contentKey="landlordPortal.documentTemplate.noteGoesHere" />

          {isConditionalAddendum && (
            <InputNumber
              contentKey="landlordPortal.documentTemplate.rentableItems"
              name={'max_rentable_items'}
              min={minRentableItems}
              value={numOfRentableItems}
              callback={(newValue) => setInputValue('max_rentable_items', newValue)}
            />
          )}
          {isLease && (
            <InputNumber
              contentKey="landlordPortal.documentTemplate.incentives"
              name={'max_incentives'}
              min={minIncentives}
              value={numOfIncentives}
              callback={(newValue) => setInputValue('max_incentives', newValue)}
            />
          )}
        </React.Fragment>
      )}
    </InputNumberContainer>
  );
};
